var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHoroscope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.002 4a2 2 0 100-4 2 2 0 000 4zm11.496-.004a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-11 11a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.002 0l3 5 4 3-4 3-3 5-3-5-4-3 4-3 3-5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMi4wMDE5NSA0YzEuMTA0NTcgMCAyLjAwMDAxLS44OTU0MyAyLjAwMDAxLTJzLS44OTU0NC0yLTIuMDAwMDEtMi0yIC44OTU0My0yIDIgLjg5NTQzIDIgMiAyek0xMy40OTggMy45OTYwOGMuODI4NSAwIDEuNS0uNjcxNTcgMS41LTEuNDk5OTkgMC0uODI4NDMtLjY3MTUtMS41LTEuNS0xLjUtLjgyODQgMC0xLjUuNjcxNTctMS41IDEuNSAwIC44Mjg0Mi42NzE2IDEuNDk5OTkgMS41IDEuNDk5OTl6TTIuNDk4MDQgMTQuOTk2MWMuODI4NDMgMCAxLjUtLjY3MTYgMS41LTEuNXMtLjY3MTU3LTEuNS0xLjUtMS41Yy0uODI4NDIgMC0xLjUuNjcxNi0xLjUgMS41cy42NzE1OCAxLjUgMS41IDEuNXoiLz4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguMDAxOTYgMGwzLjAwMDI0IDQuOTk5NCAzLjk5OTggMy4wMDAyMi0zLjk5OTggMy4wMDAxOC0zLjAwMDI0IDQuOTk5NC0zLjAwMDIxLTQuOTk5NC0zLjk5OTgtMy4wMDAxOCAzLjk5OTgtMy4wMDAyMkw4LjAwMTk2IDB6Ii8+Cjwvc3ZnPgo=";
export { SvgHoroscope as ReactComponent };